import { Injectable, inject } from '@angular/core';
import { ActionSheetController } from '@ionic/angular';
import { Params, Router } from '@angular/router';
import { ROUTE_URLS } from '@ers-cat-app/shared/constants/routes';

@Injectable({
  providedIn: 'root',
})
export class LeavePageService {
  private actionSheetCtrl = inject(ActionSheetController);
  private router = inject(Router);


  async confirmLeavePage(url: string, args?: Params): Promise<void> {
    const confirmationPrompt = await this.actionSheetCtrl.create({
      header: `Are you sure you want to leave this page? All data will be lost.`,
      buttons: [
        {
          text: 'Yes',
          role: 'confirm',
          handler: () => {
            this.router.navigateByUrl(url, { replaceUrl: true, ...args });
          },
        },
        {
          text: 'No',
          role: 'cancel',
        },
      ],
    });

    await confirmationPrompt.present();
  }
}
